import React from "react";

interface InstagramIconProps {
    width?: number;
    height?: number;
    fill?: string;
    className?: string;
}

const Instagram: React.FC<InstagramIconProps> = ({ width, height,className,  fill = "url(#paint0_linear_113_578)"}) => {
    const isGradient = fill === "url(#paint0_linear_113_578)";
    
    return (
        <svg xmlns="http://www.w3.org/2000/svg" 
        width={width} 
        height={height} 
        viewBox="0 0 48 48" 
        fill="none"
        className={className}>
            <defs>
                <linearGradient id="paint0_linear_113_578" x1="7.60466" y1="44" x2="49.4969" y2="28.326" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFDC7D" />
                    <stop offset="0.2" stopColor="#F46F30" />
                    <stop offset="0.45" stopColor="#C32AA3" />
                    <stop offset="0.7" stopColor="#7232BD" />
                    <stop offset="1" stopColor="#4C5FD7" />
                </linearGradient>
            </defs>
            <path
                d="M15.6 4H32.4C38.8 4 44 9.2 44 15.6V32.4C44 35.4765 42.7779 38.427 40.6024 40.6024C38.427 42.7779 35.4765 44 32.4 44H15.6C9.2 44 4 38.8 4 32.4V15.6C4 12.5235 5.22214 9.57298 7.39756 7.39756C9.57298 5.22214 12.5235 4 15.6 4ZM15.2 8C13.2904 8 11.4591 8.75857 10.1088 10.1088C8.75857 11.4591 8 13.2904 8 15.2V32.8C8 36.78 11.22 40 15.2 40H32.8C34.7096 40 36.5409 39.2414 37.8912 37.8912C39.2414 36.5409 40 34.7096 40 32.8V15.2C40 11.22 36.78 8 32.8 8H15.2ZM34.5 11C35.163 11 35.7989 11.2634 36.2678 11.7322C36.7366 12.2011 37 12.837 37 13.5C37 14.163 36.7366 14.7989 36.2678 15.2678C35.7989 15.7366 35.163 16 34.5 16C33.837 16 33.2011 15.7366 32.7322 15.2678C32.2634 14.7989 32 14.163 32 13.5C32 12.837 32.2634 12.2011 32.7322 11.7322C33.2011 11.2634 33.837 11 34.5 11ZM24 14C26.6522 14 29.1957 15.0536 31.0711 16.9289C32.9464 18.8043 34 21.3478 34 24C34 26.6522 32.9464 29.1957 31.0711 31.0711C29.1957 32.9464 26.6522 34 24 34C21.3478 34 18.8043 32.9464 16.9289 31.0711C15.0536 29.1957 14 26.6522 14 24C14 21.3478 15.0536 18.8043 16.9289 16.9289C18.8043 15.0536 21.3478 14 24 14ZM24 18C22.4087 18 20.8826 18.6321 19.7574 19.7574C18.6321 20.8826 18 22.4087 18 24C18 25.5913 18.6321 27.1174 19.7574 28.2426C20.8826 29.3679 22.4087 30 24 30C25.5913 30 27.1174 29.3679 28.2426 28.2426C29.3679 27.1174 30 25.5913 30 24C30 22.4087 29.3679 20.8826 28.2426 19.7574C27.1174 18.6321 25.5913 18 24 18Z"
                fill={isGradient ? "url(#paint0_linear_113_578)" : fill} // Usar el gradiente o color sólido según la propiedad
            />
        </svg>
    )
}

export default Instagram